import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useRoutes from '../hooks/useRoutes';

function LinesList() {
  const [searchTerm, setSearchTerm] = useState('');
  const { filteredRoutes, loading, error } = useRoutes(searchTerm);

  if (loading) return <div className="loading">Ładowanie listy linii...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="lines-container">
      <h1>Rozkład jazdy</h1>

      <div className="search-container">
        <input
          type="search"
          placeholder="Wyszukaj linię..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
          aria-label="Wyszukaj linię"
          autoComplete="off"
        />
      </div>

      {filteredRoutes.length === 0 ? (
        <div className="no-departures">Nie znaleziono linii.</div>
      ) : (
        <div className="lines-grid">
          {filteredRoutes.map((route) => {
            const isTram = route.routeType === 'TRAM';
            return (
              <Link
                key={route.routeId}
                to={`/rozklad/${route.routeId}`}
                className={`line-card ${isTram ? 'line-card--tram' : 'line-card--bus'}`}
              >
                <span className={`line-badge ${isTram ? 'line-badge--tram' : ''}`}>
                  {route.routeShortName}
                </span>
                <span className="line-name">{route.routeLongName}</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default LinesList;
